import { usePickerContext } from "./usePickerContext";
import { Caller } from "../../../core/Caller";
import { useCallback, useEffect, useMemo } from "react";
import { useCallerHandler } from "./useCallerHandler";
import { graphic } from "../../lib/graphic/Graphic";
import { graphicEvents } from "../../lib/graphic/GraphicEvents";
import { TYPES } from "../../lib/graphic/EntityManager"

export const STATUS = {
    FETCH: 'FETCH',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
};

export const usePickerCore = () => {

    function checkPitStock(pitId, categoryId) {
        // Calcul du stock restant apr�s ajout d'un billet
        const currentDate = state.dates.find(date => date.current)
        let currentHourValue = Object.keys(currentDate.hours).find(value => currentDate.hours[value].current);
        if(currentHourValue === undefined){
            currentHourValue = Object.keys(currentDate.hours)[0]
        }
        const currentHour = currentDate.hours[currentHourValue];
        const currentCategoryPricing = currentHour.widget.categoriesPrices.find(categoryPrice => categoryPrice.categoryId === categoryId);
        const tickets = state.tickets.filter(t =>
            t.at === currentDate.at &&
            (t.hour === currentHourValue || !currentHourValue) &&
            t.categoryId === categoryId
        );
        const restStock = currentCategoryPricing.countStock - tickets.length - 1

        const pitEntity = graphic.entityManager.get(TYPES.PIT, pitId);
        if (restStock === 0) pitEntity.disable({reason: 'Complet'});
        else pitEntity.enable();
    }

    const { state, dispatch } = usePickerContext();
    const handler = useCallerHandler(dispatch);

    const caller = useMemo(() => new Caller({
        baseUrl: `${state.url}/placement`
    }), []);

    useEffect(() => {
        if (state.isLoaded) state.tickets.forEach(({ seatReference, pitId }) => {
            if (seatReference) graphicEvents.trigger('SET_SELECTED_SEAT', { seatReference });
            else if (pitId) graphicEvents.trigger('ADD_TICKET_PIT', { id: pitId });
        });
    }, [state.isLoaded]);

    return {

        getConfiguration: () => {
            handler('GET_CONFIG', async () => await caller.call({
                action: 'getConfiguration',
                provider: state.provider
            }));
        },

        getDates: () => {
            handler('GET_DATES', async () => await caller.call({
                action: 'getAvailableDates',
                provider: state.provider
            }));
        },

        getWidget: ({ date }) => {
            // console.log(date)
            const currentHoursValue = Object.keys(date.hours).find(value => date.hours[value].current);
            // console.log(currentHoursValue)
            const currentHour = date.hours[currentHoursValue];
            if (!currentHour.widget) {
                handler('GET_WIDGET', async () => await caller.call({
                    action: 'getFrontPickerWidget',
                    startDate: date.at,
                    roomId: currentHour.roomId,
                    mode: state.typeWidget === 'FREE' ? 'free' : 'multiPass',
                    back: state.back,
                    otiPassCode: state.otiPassCode || null
                }));
            }
        },

        getMultiWidget: ({ dates }) => {
            const datesNotLoaded = dates.filter(date => !date.widget)
            if (datesNotLoaded.length > 0) {
                const dates = datesNotLoaded.map(date => ({
                    at: date.at,
                    roomId: date.roomId,
                    hour: Object.keys(date.hours)[0]
                }))
                handler('GET_MULTI_WIDGET', async () => await caller.call({
                    action: 'getFrontPickerWidget',
                    dates: JSON.stringify(dates),
                    mode: state.typeWidget === 'FREE' ? 'free' : 'multiPass',
                    back: state.back,
                    provider: state.provider,
                    otiPassCode: state.otiPassCode || null
                }));
            }
        },

        getSteps: () => {
            handler('GET_STEPS', async () => await caller.call({
                action: 'getFrontPickerWidgetMultiPass',
                provider: state.provider,
                back: state.back
            }));
        },

        onSaveBooking: (data) => {
            const date = state.dates.find(date => date.current);
            if (state.externe) {
                handler('UPSERT_BOOKING', async () => await caller.call({
                    data: JSON.stringify(data),
                    status: "get",
                    roomId: date.roomId,
                    startDate: date.at,
                    action: state.typeWidget === 'FREE'
                        ? 'upsertBookingFree'
                        : 'upsertBookingMultiPass'
                }));
            } else {
                handler('UPSERT_BOOKING', async () => await caller.post({
                    params: {
                        roomId: date.roomId,
                        startDate: date.at,
                        action: state.typeWidget === 'FREE'
                            ? 'upsertBookingFree'
                            : 'upsertBookingMultiPass'
                    },
                    body: JSON.stringify(data)
                }));
            }
        },

        onSelectSeat: useCallback(({ seatReference, categoryId }) => {
            dispatch({
                type: 'ADD_TICKET',
                payload: {
                    type: 'SEAT',
                    id: seatReference,
                    categoryId
                }
            });
        }, [state.tickets]),

        onUnselectSeat: useCallback(({ seatReference }) => {
            const currentDate = state.dates.find(date => date.current)
            const ticket = state.tickets.find(ticket => ticket.id === seatReference && ticket.at === currentDate.at);
            if (ticket) dispatch({
                type: 'DELETE_TICKET',
                payload: ticket
            });
        }, [state.tickets]),

        onSelectPit: useCallback(({ pitId, categoryId }) => {
            checkPitStock(pitId, categoryId);
            dispatch({
                type: 'ADD_TICKET',
                payload: {
                    type: 'PIT',
                    id: pitId,
                    categoryId
                }
            });
        }, [state.tickets]),

        deleteTicket: useCallback((ticket) => {
            switch (ticket.type) {
                case 'SEAT': {
                    graphicEvents.trigger('SET_UNSELECTED_SEAT', {
                        seatReference: ticket.id
                    });
                    break;
                }
                case 'PIT': {
                    checkPitStock(ticket.id, ticket.categoryId)
                    graphicEvents.trigger('REMOVE_TICKET_PIT', {
                        pitId: ticket.id
                    });
                    break;
                }
            }
            dispatch({ type: 'DELETE_TICKET', payload: ticket });
        }, []),

        changeFormulaTicket: useCallback((ticket, formula) => {
            dispatch({
                type: 'SET_FORMULA_TICKET',
                payload: { ticket, formula }
            });
        }, []),

        changePassTicket: useCallback((ticket, passCode) => {
            dispatch({
                type: 'SET_PASS_TICKET',
                payload: { ticket, passCode }
            });
        }, []),
    }
};